export default __webpack_public_path__ + "Kuantum2.pdf";